var parseVersion = (str) => {
	// see webpack/lib/util/semver.js for original code
	var p=p=>{return p.split(".").map(p=>{return+p==p?+p:p})},n=/^([^-+]+)?(?:-([^+]+))?(?:\+(.+))?$/.exec(str),r=n[1]?p(n[1]):[];return n[2]&&(r.length++,r.push.apply(r,p(n[2]))),n[3]&&(r.push([]),r.push.apply(r,p(n[3]))),r;
}
var versionLt = (a, b) => {
	// see webpack/lib/util/semver.js for original code
	a=parseVersion(a),b=parseVersion(b);for(var r=0;;){if(r>=a.length)return r<b.length&&"u"!=(typeof b[r])[0];var e=a[r],n=(typeof e)[0];if(r>=b.length)return"u"==n;var t=b[r],f=(typeof t)[0];if(n!=f)return"o"==n&&"n"==f||("s"==f||"u"==n);if("o"!=n&&"u"!=n&&e!=t)return e<t;r++}
}
var rangeToString = (range) => {
	// see webpack/lib/util/semver.js for original code
	var r=range[0],n="";if(1===range.length)return"*";if(r+.5){n+=0==r?">=":-1==r?"<":1==r?"^":2==r?"~":r>0?"=":"!=";for(var e=1,a=1;a<range.length;a++){e--,n+="u"==(typeof(t=range[a]))[0]?"-":(e>0?".":"")+(e=2,t)}return n}var g=[];for(a=1;a<range.length;a++){var t=range[a];g.push(0===t?"not("+o()+")":1===t?"("+o()+" || "+o()+")":2===t?g.pop()+" "+g.pop():rangeToString(t))}return o();function o(){return g.pop().replace(/^\((.+)\)$/,"$1")}
}
var satisfy = (range, version) => {
	// see webpack/lib/util/semver.js for original code
	if(0 in range){version=parseVersion(version);var e=range[0],r=e<0;r&&(e=-e-1);for(var n=0,i=1,a=!0;;i++,n++){var f,s,g=i<range.length?(typeof range[i])[0]:"";if(n>=version.length||"o"==(s=(typeof(f=version[n]))[0]))return!a||("u"==g?i>e&&!r:""==g!=r);if("u"==s){if(!a||"u"!=g)return!1}else if(a)if(g==s)if(i<=e){if(f!=range[i])return!1}else{if(r?f>range[i]:f<range[i])return!1;f!=range[i]&&(a=!1)}else if("s"!=g&&"n"!=g){if(r||i<=e)return!1;a=!1,i--}else{if(i<=e||s<g!=r)return!1;a=!1}else"s"!=g&&"n"!=g&&(a=!1,i--)}}var t=[],o=t.pop.bind(t);for(n=1;n<range.length;n++){var u=range[n];t.push(1==u?o()|o():2==u?o()&o():u?satisfy(u,version):!o())}return!!o();
}
const exists = (scope, key) => {
	return scope && __webpack_require__.o(scope, key);
}
const get = (entry) => {
	entry.loaded = 1;
	return entry.get()
};
const eagerOnly = (versions) => {
	return Object.keys(versions).reduce((filtered, version) => {
			if (versions[version].eager) {
				filtered[version] = versions[version];
			}
			return filtered;
	}, {});
};
const findLatestVersion = (scope, key, eager) => {
	const versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key];
};
const findSatisfyingVersion = (scope, key, requiredVersion, eager) => {
	const versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		if (!satisfy(requiredVersion, b)) return a;
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
const findSingletonVersionKey = (scope, key, eager) => {
	const versions = eager ? eagerOnly(scope[key]) : scope[key];
	return Object.keys(versions).reduce((a, b) => {
		return !a || (!versions[a].loaded && versionLt(a, b)) ? b : a;
	}, 0);
};
const getInvalidSingletonVersionMessage = (scope, key, version, requiredVersion) => {
	return "Unsatisfied version " + version + " from " + (version && scope[key][version].from) + " of shared singleton module " + key + " (required " + rangeToString(requiredVersion) + ")"
};
const getInvalidVersionMessage = (scope, scopeName, key, requiredVersion, eager) => {
	const versions = scope[key];
	return "No satisfying version (" + rangeToString(requiredVersion) + ")" + (eager ? " for eager consumption" : "") + " of shared module " + key + " found in shared scope " + scopeName + ".\n" +
		"Available versions: " + Object.keys(versions).map((key) => {
		return key + " from " + versions[key].from;
	}).join(", ");
};
const fail = (msg) => {
	throw new Error(msg);
}
const failAsNotExist = (scopeName, key) => {
	return fail("Shared module " + key + " doesn't exist in shared scope " + scopeName);
}
const warn = /*#__PURE__*/ (msg) => {
	if (typeof console !== "undefined" && console.warn) console.warn(msg);
};
const init = (fn) => (function(scopeName, key, eager, c, d) {
	const promise = __webpack_require__.I(scopeName);
	if (promise?.then && !eager) {
		return promise.then(fn.bind(fn, scopeName, __webpack_require__.S[scopeName], key, false, c, d));
	}
	return fn(scopeName, __webpack_require__.S[scopeName], key, eager, c, d);
});

const useFallback = (scopeName, key, fallback) => {
	return fallback ? fallback() : failAsNotExist(scopeName, key);
}
const load = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	return get(findLatestVersion(scope, key, eager));
});
const loadVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	const satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	warn(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager))
	return get(findLatestVersion(scope, key, eager));
});
const loadStrictVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	const satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	if (fallback) return fallback();
	fail(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager));
});
const loadSingleton = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	const version = findSingletonVersionKey(scope, key, eager);
	return get(scope[key][version]);
});
const loadSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	const version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		warn(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
const loadStrictSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	const version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		fail(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
const installedModules = {};
const moduleToHandlerMapping = {
	23055: () => (loadSingletonVersion("default", "@innovyze/lib_get_remote", false, [2,0,4,0], () => (Promise.all([__webpack_require__.e(69440), __webpack_require__.e(95406)]).then(() => (() => (__webpack_require__(795406))))))),
	405989: () => (loadSingletonVersion("default", "react", false, [1,17,0,0], () => (__webpack_require__.e(70355).then(() => (() => (__webpack_require__(370355))))))),
	330735: () => (loadSingletonVersion("default", "react-dom", false, [1,17,0,0], () => (__webpack_require__.e(54622).then(() => (() => (__webpack_require__(854622))))))),
	866864: () => (loadSingletonVersion("default", "@emotion/react", false, [1,11,0,0], () => (Promise.all([__webpack_require__.e(92920), __webpack_require__.e(63312)]).then(() => (() => (__webpack_require__(340931))))))),
	410660: () => (loadSingletonVersion("default", "@emotion/styled", false, [1,11,0,0], () => (__webpack_require__.e(95365).then(() => (() => (__webpack_require__(217746))))))),
	763842: () => (loadSingletonVersion("default", "@innovyze/stylovyze", false, [1,1,0,0], () => (Promise.all([__webpack_require__.e(92920), __webpack_require__.e(27127), __webpack_require__.e(70427), __webpack_require__.e(28270), __webpack_require__.e(46045), __webpack_require__.e(28837), __webpack_require__.e(48447), __webpack_require__.e(33536), __webpack_require__.e(46992), __webpack_require__.e(43124), __webpack_require__.e(32560), __webpack_require__.e(45248), __webpack_require__.e(69440), __webpack_require__.e(81633), __webpack_require__.e(39576), __webpack_require__.e(31420), __webpack_require__.e(46481), __webpack_require__.e(31278), __webpack_require__.e(56676), __webpack_require__.e(74662), __webpack_require__.e(70397), __webpack_require__.e(32703), __webpack_require__.e(35668), __webpack_require__.e(98350), __webpack_require__.e(5989), __webpack_require__.e(30735), __webpack_require__.e(66864), __webpack_require__.e(10660), __webpack_require__.e(96881), __webpack_require__.e(25185), __webpack_require__.e(91202), __webpack_require__.e(35469), __webpack_require__.e(12135), __webpack_require__.e(34627), __webpack_require__.e(54528), __webpack_require__.e(21185), __webpack_require__.e(58224)]).then(() => (() => (__webpack_require__(698350))))))),
	494927: () => (loadStrictVersion("default", "@reduxjs/toolkit", false, [0,1,3], () => (Promise.all([__webpack_require__.e(93133), __webpack_require__.e(88517), __webpack_require__.e(85195)]).then(() => (() => (__webpack_require__(593133))))))),
	82064: () => (loadSingletonVersion("default", "styled-components", false, [1,5,0,0], () => (__webpack_require__.e(50423).then(() => (() => (__webpack_require__(50423))))))),
	181681: () => (loadStrictVersion("default", "react-i18next", false, [1,11,0,0], () => (__webpack_require__.e(49189).then(() => (() => (__webpack_require__(971570))))))),
	643345: () => (loadSingletonVersion("default", "react-redux", false, [1,7,0,0], () => (Promise.all([__webpack_require__.e(52307), __webpack_require__.e(30735)]).then(() => (() => (__webpack_require__(552307))))))),
	721150: () => (loadSingletonVersion("default", "@mui/material", false, [1,5,0,0], () => (Promise.all([__webpack_require__.e(70427), __webpack_require__.e(46045), __webpack_require__.e(4754), __webpack_require__.e(46992), __webpack_require__.e(43124), __webpack_require__.e(26825), __webpack_require__.e(63796), __webpack_require__.e(32560), __webpack_require__.e(40796), __webpack_require__.e(31420), __webpack_require__.e(93067), __webpack_require__.e(30735)]).then(() => (() => (__webpack_require__(693067))))))),
	264418: () => (loadSingletonVersion("default", "@mui/icons-material", false, [1,5,0,0], () => (__webpack_require__.e(79795).then(() => (() => (__webpack_require__(679795))))))),
	690484: () => (loadSingletonVersion("default", "react-router-dom", false, [1,5,0,0], () => (__webpack_require__.e(92891).then(() => (() => (__webpack_require__(292891))))))),
	957850: () => (loadSingletonVersion("default", "@innovyze/lib_get_service", false, [2,0,1,0], () => (Promise.all([__webpack_require__.e(56676), __webpack_require__.e(35668), __webpack_require__.e(23811), __webpack_require__.e(21185), __webpack_require__.e(70996)]).then(() => (() => (__webpack_require__(23811))))))),
	376868: () => (loadSingletonVersion("default", "@innovyze/lib_asset_schema_store", false, [2,0,6,0], () => (__webpack_require__.e(32699).then(() => (() => (__webpack_require__(832699))))))),
	281956: () => (loadStrictVersion("default", "yup", false, [2,0,32,9], () => (Promise.all([__webpack_require__.e(56676), __webpack_require__.e(32703), __webpack_require__.e(14944)]).then(() => (() => (__webpack_require__(914944))))))),
	112135: () => (loadSingletonVersion("default", "formik", false, [1,2,0,0], () => (Promise.all([__webpack_require__.e(73403), __webpack_require__.e(60836)]).then(() => (() => (__webpack_require__(860836))))))),
	25293: () => (loadStrictVersion("default", "@innovyze/inno-map", false, [1,3,49,0], () => (Promise.all([__webpack_require__.e(46045), __webpack_require__.e(28837), __webpack_require__.e(4754), __webpack_require__.e(48447), __webpack_require__.e(33536), __webpack_require__.e(46992), __webpack_require__.e(32560), __webpack_require__.e(40796), __webpack_require__.e(81633), __webpack_require__.e(39576), __webpack_require__.e(70136), __webpack_require__.e(18930), __webpack_require__.e(91202), __webpack_require__.e(76868), __webpack_require__.e(28142), __webpack_require__.e(40815), __webpack_require__.e(41234)]).then(() => (() => (__webpack_require__(318930))))))),
	217426: () => (loadStrictVersion("default", "@innovyze/shared-utils", false, [2,0,1,116], () => (Promise.all([__webpack_require__.e(28837), __webpack_require__.e(48447), __webpack_require__.e(99120), __webpack_require__.e(48551)]).then(() => (() => (__webpack_require__(599120))))))),
	725339: () => (loadStrictVersion("default", "@weave-design/toggle", false, [1,1,0,0], () => (Promise.all([__webpack_require__.e(46481), __webpack_require__.e(34627), __webpack_require__.e(59170)]).then(() => (() => (__webpack_require__(636789))))))),
	215217: () => (loadStrictVersion("default", "moment-timezone", false, [2,0,5,32], () => (Promise.all([__webpack_require__.e(68188), __webpack_require__.e(49388), __webpack_require__.e(35358)]).then(() => (() => (__webpack_require__(449388))))))),
	869801: () => (loadStrictVersion("default", "redux", false, [0,4,0], () => (__webpack_require__.e(55062).then(() => (() => (__webpack_require__(855062))))))),
	168050: () => (loadStrictVersion("default", "redux-saga", false, [1,1,1,3], () => (__webpack_require__.e(61568).then(() => (() => (__webpack_require__(539187))))))),
	368902: () => (loadStrictVersion("default", "redux", false, [,[1,4,0,0],[1,3,1,0],1], () => (__webpack_require__.e(55062).then(() => (() => (__webpack_require__(855062))))))),
	791202: () => (loadStrictVersion("default", "luxon", false, [1,2,0,0], () => (__webpack_require__.e(28097).then(() => (() => (__webpack_require__(628097))))))),
	128142: () => (loadStrictVersion("default", "i18next", false, [1,21,8,0], () => (Promise.all([__webpack_require__.e(45677), __webpack_require__.e(26941)]).then(() => (() => (__webpack_require__(945677))))))),
	81137: () => (loadStrictVersion("default", "redux", false, [1,4,1,2], () => (__webpack_require__.e(32681).then(() => (() => (__webpack_require__(855062))))))),
	122190: () => (loadStrictVersion("default", "@innovyze/shared-utils", false, [1,1,0,0], () => (Promise.all([__webpack_require__.e(99120), __webpack_require__.e(48246)]).then(() => (() => (__webpack_require__(599120))))))),
	195717: () => (loadStrictVersion("default", "@reduxjs/toolkit", false, [1,1,9,7], () => (Promise.all([__webpack_require__.e(93133), __webpack_require__.e(88517), __webpack_require__.e(40372)]).then(() => (() => (__webpack_require__(593133))))))),
	265736: () => (loadSingletonVersion("default", "@innovyze/lib_asset_schema", false, [2,0,6,0], () => (__webpack_require__.e(94701).then(() => (() => (__webpack_require__(494701))))))),
	784596: () => (loadStrictVersion("default", "@innovyze/shared-utils", false, [1,1,0,0], () => (Promise.all([__webpack_require__.e(48686), __webpack_require__.e(15832)]).then(() => (() => (__webpack_require__(348686))))))),
	887578: () => (loadSingletonVersion("default", "@innovyze/summaryze", false, [2,0,4,0], () => (Promise.all([__webpack_require__.e(79795), __webpack_require__.e(69440), __webpack_require__.e(30412), __webpack_require__.e(74662), __webpack_require__.e(42315), __webpack_require__.e(88517), __webpack_require__.e(54528), __webpack_require__.e(13799), __webpack_require__.e(12062)]).then(() => (() => (__webpack_require__(542315))))))),
	321185: () => (loadStrictVersion("default", "browser-cookies", false, [1,1,2,0], () => (__webpack_require__.e(53145).then(() => (() => (__webpack_require__(453145))))))),
	870996: () => (loadStrictVersion("default", "axios", false, [1,1,7,7], () => (Promise.all([__webpack_require__.e(72339), __webpack_require__.e(18957)]).then(() => (() => (__webpack_require__(772339))))))),
	234627: () => (loadStrictVersion("default", "@weave-design/theme-context", false, [1,1,0,0], () => (__webpack_require__.e(51704).then(() => (() => (__webpack_require__(351704))))))),
	454528: () => (loadSingletonVersion("default", "@mui/x-date-pickers-pro", false, [1,7,0,0], () => (Promise.all([__webpack_require__.e(70427), __webpack_require__.e(46045), __webpack_require__.e(4754), __webpack_require__.e(63796), __webpack_require__.e(72912), __webpack_require__.e(69829), __webpack_require__.e(30735), __webpack_require__.e(96668)]).then(() => (() => (__webpack_require__(869829))))))),
	196514: () => (loadStrictVersion("default", "axios", false, [1,1,15,0], () => (__webpack_require__.e(72339).then(() => (() => (__webpack_require__(772339))))))),
	270737: () => (loadStrictVersion("default", "leaflet", false, [1,1,8,0], () => (__webpack_require__.e(78564).then(() => (() => (__webpack_require__(878564))))))),
	351575: () => (loadStrictVersion("default", "axios-retry", false, [1,3,9,0], () => (__webpack_require__.e(65938).then(() => (() => (__webpack_require__(665938))))))),
	397926: () => (loadStrictVersion("default", "i18next", false, [1,21,0,0], () => (__webpack_require__.e(45677).then(() => (() => (__webpack_require__(945677))))))),
	478543: () => (loadStrictVersion("default", "@innovyze/shared-utils", false, [1,1,0,3], () => (Promise.all([__webpack_require__.e(92024), __webpack_require__.e(78872)]).then(() => (() => (__webpack_require__(292024))))))),
	478583: () => (loadStrictVersion("default", "i18next-resources-to-backend", false, [1,1,0,0], () => (__webpack_require__.e(93604).then(() => (() => (__webpack_require__(693604))))))),
	514718: () => (loadStrictVersion("default", "axios", false, [1,1,20,0], () => (__webpack_require__.e(72339).then(() => (() => (__webpack_require__(772339))))))),
	633071: () => (loadStrictVersion("default", "@reduxjs/toolkit", false, [1,1,0,0], () => (Promise.all([__webpack_require__.e(93133), __webpack_require__.e(88517), __webpack_require__.e(40372)]).then(() => (() => (__webpack_require__(593133))))))),
	798398: () => (loadStrictVersion("default", "yup", false, [4,0,31,1], () => (Promise.all([__webpack_require__.e(73403), __webpack_require__.e(41369)]).then(() => (() => (__webpack_require__(641369))))))),
	812276: () => (loadStrictVersion("default", "leaflet-draw", false, [1,1,0,4], () => (__webpack_require__.e(58036).then(() => (() => (__webpack_require__(158036))))))),
	871342: () => (loadSingletonVersion("default", "@mui/styles", false, [1,5,0,0], () => (__webpack_require__.e(53221).then(() => (() => (__webpack_require__(153221))))))),
	588517: () => (loadStrictVersion("default", "redux", false, [1,4,2,1], () => (__webpack_require__.e(55062).then(() => (() => (__webpack_require__(855062))))))),
	112337: () => (loadStrictVersion("default", "moment-timezone", false, [2,0,5,43], () => (Promise.all([__webpack_require__.e(68188), __webpack_require__.e(49388), __webpack_require__.e(35358)]).then(() => (() => (__webpack_require__(449388))))))),
	242862: () => (loadStrictVersion("default", "@innovyze/shared-utils", false, [1,1,0,2], () => (__webpack_require__.e(30530).then(() => (() => (__webpack_require__(830530))))))),
	364292: () => (loadStrictVersion("default", "axios-retry", false, [1,3,8,0], () => (__webpack_require__.e(65938).then(() => (() => (__webpack_require__(665938))))))),
	829774: () => (loadStrictVersion("default", "@reduxjs/toolkit", false, [1,1,9,6], () => (Promise.all([__webpack_require__.e(93133), __webpack_require__.e(13802)]).then(() => (() => (__webpack_require__(593133))))))),
	970192: () => (loadStrictVersion("default", "axios", false, [1,1,5,1], () => (Promise.all([__webpack_require__.e(72339), __webpack_require__.e(18957)]).then(() => (() => (__webpack_require__(772339))))))),
	247065: () => (loadSingletonVersion("default", "@mui/x-date-pickers/DateTimePicker", false, [0], () => (Promise.all([__webpack_require__.e(26825), __webpack_require__.e(83487)]).then(() => (() => (__webpack_require__(83487))))))),
	327301: () => (loadSingletonVersion("default", "@mui/x-date-pickers/LocalizationProvider", false, [0], () => (__webpack_require__.e(3448).then(() => (() => (__webpack_require__(303448))))))),
	897064: () => (loadSingletonVersion("default", "@mui/x-date-pickers", false, [1,7,0,0], () => (Promise.all([__webpack_require__.e(26825), __webpack_require__.e(83487), __webpack_require__.e(44922)]).then(() => (() => (__webpack_require__(44922)))))))
};
// no consumes in initial chunks
const chunkMapping = {
	"5989": [
		405989
	],
	"10660": [
		410660
	],
	"12135": [
		112135
	],
	"13799": [
		112337,
		242862,
		364292,
		829774,
		970192
	],
	"21185": [
		321185
	],
	"22531": [
		869801
	],
	"23055": [
		23055
	],
	"25185": [
		264418,
		690484
	],
	"27355": [
		494927
	],
	"28142": [
		128142
	],
	"30735": [
		330735
	],
	"34627": [
		234627
	],
	"35469": [
		957850
	],
	"40815": [
		81137,
		122190,
		195717,
		265736,
		784596,
		887578
	],
	"41418": [
		168050,
		368902
	],
	"54528": [
		454528
	],
	"55085": [
		25293,
		217426,
		725339
	],
	"58224": [
		196514,
		270737,
		351575,
		397926,
		478543,
		478583,
		514718,
		633071,
		798398,
		812276,
		871342
	],
	"63842": [
		763842
	],
	"66864": [
		866864
	],
	"70996": [
		870996
	],
	"76868": [
		376868
	],
	"81956": [
		281956
	],
	"84706": [
		215217
	],
	"88517": [
		588517
	],
	"91202": [
		791202
	],
	"96668": [
		247065,
		327301,
		897064
	],
	"96881": [
		82064,
		181681,
		643345,
		721150
	]
};
const startedInstallModules = {};
__webpack_require__.f.consumes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			if(__webpack_require__.o(installedModules, id)) return promises.push(installedModules[id]);
			if(!startedInstallModules[id]) {
			const onFactory = (factory) => {
				installedModules[id] = 0;
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					module.exports = factory();
				}
			};
			startedInstallModules[id] = true;
			const onError = (error) => {
				delete installedModules[id];
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					throw error;
				}
			};
			try {
				const promise = moduleToHandlerMapping[id]();
				if(promise.then) {
					promises.push(installedModules[id] = promise.then(onFactory)['catch'](onError));
				} else onFactory(promise);
			} catch(e) { onError(e); }
			}
		});
	}
}